import { useMutation, useQueryClient } from "@tanstack/react-query";
import commentService from "../api/commentService";

export const useCreateComment = () => {
  const { createComment } = commentService();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["create-comment"],
    mutationFn: async ({ comment }) => {
      const response = await createComment(comment);
      return response.data;
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["get-comments", variables.comment.TaskId],
      });
      queryClient.invalidateQueries({
        queryKey: ["get-activity-logs", variables.comment.TaskId],
      });
    },
  });
};

export const useUpdateComment = () => {
  const { updateComment } = commentService();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ["update-comment"],
    mutationFn: async ({ comment }) => {
      const response = await updateComment(comment);
      return response.data;
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["get-comments", variables.taskId],
      });
      queryClient.invalidateQueries({
        queryKey: ["get-activity-logs", variables.taskId],
      });
    },
  });
};

export const useDeleteComment = (callback) => {
  const { deleteComment } = commentService();
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["delete-comment"],
    mutationFn: async ({ commentId }) => {
      const response = await deleteComment(commentId);
      return response.data;
    },
    onSuccess: (data, variables) => {
      callback?.(data, variables);
      queryClient.invalidateQueries({
        queryKey: ["get-comments", variables.taskId],
      });
      queryClient.invalidateQueries({
        queryKey: ["get-activity-logs", variables.taskId],
      });
    },
  });
};
